import {useCallback} from 'react';
import type {LinkedValueSearchFieldConfig} from 'feature/linkedValueSearch/types';
import {useLinkedValueSearchFieldContext} from './useLinkedValueSearchFieldContext';

export const useOpenSearch = () => {
  const context = useLinkedValueSearchFieldContext();

  return useCallback(
    (config?: Partial<LinkedValueSearchFieldConfig>) => {
      context.setSourceField(
        {
          fieldId: 'searchPanel',
          fieldConfig: {
            titleKey: 'general.search',
            ...config,
          },
        },
        () => undefined,
      );
    },
    [context],
  );
};
